import React from 'react';

const ReposIpfsI18n = () => (
  <div id='content' className='pt3 pr4 pl4 w-100'>
    <h1><span className='nav-category'>Repo:</span> ipfs/i18n</h1>
    <p>This repo contains the overarching information for the IPFS Translation Project. Most user-facing activity takes place on the third-party <a href="https://www.transifex.com/ipfs/public/" target="_blank" rel="noopener noreferrer">Transifex</a> platform, and translation strings themselves live within the code for the core projects being translated (<code>ipfs-companion</code>, <code>ipld-explorer-components</code>, etc). For the purposes of the mental model, however, we'll consider this <code>i18n</code> repo as the summary source. <a href="https://github.com/ipfs/i18n" target="_blank" rel="noopener noreferrer">View on GitHub</a></p>

    <h2>Nothing to see here!</h2>
    <p>This repo isn’t examined in detail because its code is primarily used as a constituent part of one or more other user-facing repos.</p>
  </div>
);

export default ReposIpfsI18n;
